import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import BannerAnalyticComponent from "../../Components/BannerAnalyticComponent/BannerAnalyticComponent";
import {
  Apiurl,
  GetLocalStorageParsed,
  parseData,
  RemoveSession,
} from "../utils/page";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const BannerAnalytic = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const FetchToken = GetLocalStorageParsed("AuthToken");

  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [bannerAnalyticData, setBannerAnalyticData] = useState();
  const [showUserDataModal, setShowUserDataModal] = useState(false);
  const [showUserPotentialData, setShowUserPotentialDataModal] =
    useState(false);
  const [showProductDataModal, setShowProductModal] = useState(false);
  const [userFilterData, setUserFilterData] = useState();
  const [getProfileData, setGetProfielData] = useState();
  const [productDataById, setProductDataById] = useState();
  const [productDataBuyUser, setProductDataBuyUser] = useState();
  const [showBuyTable, setShowBuyTable] = useState(false);
  const [loading, setLoading] = useState("");

  const GetBannerAnalytic = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/Vendor/BannerAnalytics`,
    };
    axios(option)
      .then((e) => {
        setBannerAnalyticData(parseData(e?.data?.result));
        setLoading("");
      })
      .catch((error) => {
        //  if (error?.code === "ERR_BAD_REQUEST") {
        //           RemoveSession(navigate);
        //         }
      });
  };
  useEffect(() => {
    setLoading("banner");

    GetBannerAnalytic();
  }, []);
  const handleFilterData = (e, idss) => {
    const data = {};
    data.Filter =
      idss === "userData"
        ? "View"
        : idss === "potentialData"
        ? "SaveForLater"
        : null;
    data.BannerId = e?.BannerId;

    const options = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/Vendor/UsersDetails`,
    };
    axios(options)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setUserFilterData(data);
      })
      .catch((error) => {});
  };
  const ProductsDataFromId = (e, val) => {
    setLoading("productId");

    const data = {};
    data.Id = e?.BannerId;

    const options = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/Vendor/ProductsDataFromId`,
    };
    axios(options)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setProductDataById(data);
        setLoading("");
      })
      .catch((error) => {});
  };
  const ProductsDataBuyuser = (e, val) => {
    setLoading("buyUser");

    const data = {};
    data.Id = e?.Id;

    const options = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/Vendor/GetProductAnalyticsInfo`,
    };
    axios(options)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setProductDataBuyUser(data);
        setLoading("");
      })
      .catch((error) => {});
  };
  const handleUserDataModal = () => {
    setShowUserDataModal(false);
    setUserFilterData();
  };
  const handleUserPotentialDataModal = () => {
    setShowUserPotentialDataModal(false);
    setUserFilterData();
  };
  const handleProductDataModal = () => {
    setShowProductModal(false);
    setShowBuyTable(false);
    setProductDataById();
  };
  const handlepublish = (e) => {
    const data = {};
    data.Id = e?.BannerId;

    data.IsPublish = e?.IsPublish === true ? false : true;

    const options = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/Banner/UpdateFlagForBannerAnalytic`,
    };
    axios(options)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        const data = parseData(e?.data?.result);
        GetBannerAnalytic();
      })
      .catch((error) => {});
  };

  const handleDeleteBanner = (e) => {
    const data = {};
    data.Id = e?.BannerId;

    const options = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/Banner/Delete`,
    };
    axios(options)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        const data = parseData(e?.data?.result);
        GetBannerAnalytic();
      })
      .catch((error) => {});
  };

  return (
    <>
      <div
        style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
      >
        <Header
          setGetProfielData={setGetProfielData}
          setLoginToken={setLoginToken}
        />
        <BannerAnalyticComponent
          bannerAnalyticData={bannerAnalyticData}
          handleFilterData={handleFilterData}
          setShowUserDataModal={setShowUserDataModal}
          setShowUserPotentialDataModal={setShowUserPotentialDataModal}
          showUserDataModal={showUserDataModal}
          showUserPotentialData={showUserPotentialData}
          handleUserDataModal={handleUserDataModal}
          handleUserPotentialDataModal={handleUserPotentialDataModal}
          userFilterData={userFilterData}
          ProductsDataFromId={ProductsDataFromId}
          productDataById={productDataById}
          setShowProductModal={setShowProductModal}
          showProductDataModal={showProductDataModal}
          handleProductDataModal={handleProductDataModal}
          ProductsDataBuyuser={ProductsDataBuyuser}
          productDataBuyUser={productDataBuyUser}
          showBuyTable={showBuyTable}
          setShowBuyTable={setShowBuyTable}
          handlepublish={handlepublish}
          loading={loading}
          handleDeleteBanner={handleDeleteBanner}
        />
        <Footer />
      </div>
    </>
  );
};

export default BannerAnalytic;
